var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 10.1255C0 10.9043 0.509776 11.2229 1.13266 10.8344L8.53284 6.20876C9.15572 5.81926 9.15572 5.18205 8.53284 4.79276L1.13266 0.166231C0.509776 -0.223269 0 0.095335 0 0.875196V10.1255Z","fill":"white"}));
}

IconPlay.defaultProps = {"width":"9","height":"11","viewBox":"0 0 9 11","fill":"none"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
